import { useState, useEffect } from "react";
import styles from "./MobileProfileHeader.module.css";
import MediaAssets from "assets";
import { useNavigate, useLocation } from "react-router-dom";
import { RouteConfigurations } from "routes/RouteConfigurations";
import { getItemFromLocalStorage } from "utils/LocalStorageUtils";
import { Constants } from "constants/Constants";

interface MobileHeaderInterface {
  mobileHobalImg?: string;
  mobileArrowBackIcon?: string;
  MobilBackContentColor?: string;
  MobileBackContent?: string;
  MobileSearchIcon?: string;
  MobileHamBurgerIcon?: string;
  setShowMenu?: any;
  MobileHeaderBackGroundColor?: string;
  MobileStickyHeaderBackGroundColor?: string;
  MobileHeartIcon?: string;
  MobileShareIcon?: string;
  MobileHeaderPosition?: "absolute" | "relative";
  MobileHeaderStickyPosition?: "absolute" | "relative" | "fixed";
  launchName?: string;
}

const MobileProfileHeader = (props: MobileHeaderInterface) => {
  const location: any = useLocation();
  const navigate = useNavigate();
  const token = getItemFromLocalStorage(Constants.AUTHORIZATION_TOKEN);

  const queryParams = new URLSearchParams(location.search);
  const utm_source = queryParams.get("utm_source");
  const utm_campaign = queryParams.get("utm_campaign");
  const utm_medium = queryParams.get("utm_medium");
  // console.log("utm_source", utm_source);

  const showHamburgerHandler = () => {
    props.setShowMenu(true);
  };

  const [stickyHeader, setStickyHeader] = useState<boolean | number>(false);

  useEffect(() => {
    const handleScroll = () => {
      setStickyHeader(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navigateBackHandler = () => {
    if (
      location?.pathname ===
      `/${location.pathname.split("/")[1]}/${props?.launchName}`
    ) {
      navigate(RouteConfigurations.home);
    } else {
      navigate(-1);
    }
  };

  const homeIconHandler = () => {
    if (token) {
      navigate(RouteConfigurations.home);
    } else {
      navigate(RouteConfigurations.landing);
    }
  };

  return (
    <>
      <div
        style={{
          background: stickyHeader
            ? props.MobileStickyHeaderBackGroundColor
            : props.MobileHeaderBackGroundColor,
          position: stickyHeader
            ? props.MobileHeaderStickyPosition
            : props?.MobileHeaderPosition,
                 display: utm_source ? 'none' : ''
        }}
        className={
          stickyHeader
            ? styles.mobile_sticky_header_container
            : styles.mobile_header_container
        }
      >
        <div className={styles.mobile_header_component}>
          <div className={styles.mobile_header_left_component}>
            <div className={styles.mobile_header_left_img_div}>
              <img
                src={props?.mobileHobalImg}
                style={{
                  width: "66px",
                  display: props.mobileHobalImg ? "block" : "none",
                }}
                onClick={() => homeIconHandler()}
              />
            </div>
            {!utm_source || !utm_campaign || !utm_medium ? (
              <div
                className={styles.mobile_header_left_back_div}
                onClick={() => navigateBackHandler()}
              >
                <div
                  style={{
                    display: props.mobileArrowBackIcon ? "block" : "none",
                  }}
                >
                  <img
                    src={props?.mobileArrowBackIcon}
                    style={{ width: "50px" }}
                  />
                </div>
                <div
                  style={{
                    color: props.MobilBackContentColor
                      ? props.MobilBackContentColor
                      : "#000000",
                    display: props.MobileBackContent ? "block" : "none",
                  }}
                  className={styles.mobile_header_left_back_content_style}
                >
                  {props?.MobileBackContent}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className={styles.mobile_header_right_component}>
            <div className={styles.mobile_header_right_wrapper_one}>
              {/* <div style={{ marginRight: "15px", display: props.MobileSearchIcon ? "block" : "none" }}>
                                <img
                                    src={props.MobileSearchIcon}
                                />
                            </div> */}
              <div
                onClick={() => showHamburgerHandler()}
                style={{
                  display: props.MobileHamBurgerIcon ? "block" : "none",
                }}
              >
                <img src={props.MobileHamBurgerIcon} />
              </div>
            </div>
            <div className={styles.mobile_header_right_wrapper_two}>
              {/* <div style={{ marginRight: "15px", display: props.MobileHeartIcon ? "block" : "none" }}>
                                <img
                                    src={props.MobileHeartIcon}
                                    style={{width: "50px"}}
                                />
                            </div>
                            <div style={{ display: props.MobileShareIcon ? "block" : "none" }}>
                                <img
                                    src={props.MobileShareIcon}
                                    style={{width: "50px"}}
                                />
                            </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileProfileHeader;
